module.exports = __webpack_public_path__ + "img/x.d6a91ec4.svg";